//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex';
import FlexBlock from 'components/globalBlocks/FlexBlock.vue'
import ButtonBlock from 'components/blocks/Button.vue'


export default {
  block: 'articleLoader',
  props: ['data'],
  components: {
    FlexBlock,
    ButtonBlock,
  },
  computed: {
    dataContent() {
      return {
        ...this.data,
        ...this.content
      }
      // return Object.assign(objectMerge, this.data, this.content);
    }
  },
  methods: {
    moreButtonClicked() {
      // Load more content in case buttonRedirect is false
      if (this.data.buttonRedirect == false) {
        this.loadContent();
      } else {
        // Otherwise route to path provided with buttonRedirect
        this.$router.push(this.data.buttonRedirect);
      }
    },
    resetLoadedArticles() {
      this.articleIndex = this.data.startIndex;  // Reset start index
      this.articles = [];
    },
    updateArticles() {
      this.resetLoadedArticles();
      this.currentArticleIndex = this.$route.query.article;
      // this.resetLoadedArticles();

      this.loadContent();
      document.body.scrollTo(0,0);
    },
    loadContent() {
      let articleBlock;
      let loadedArticles = 0;
      let newContent = {};

      if (this.articleIndex < 1)
        return;


      // Load (maximum) 3 more articles as long as articleIndex is not 0
      while (this.articleIndex >= 1 && loadedArticles <= 2) {

        try {
          articleBlock = require('pages/'+this.data.folder+'/'+this.data.sortedIDs[this.articleIndex]+'/article.json');

          if (articleBlock && (this.data.sortedIDs[this.articleIndex] != this.currentArticleIndex)) {

            newContent = {
              ...newContent,
              ['img'+(loadedArticles+1)]: {
                blockModifiers: ['bottomMargin','cover'],
                src: articleBlock.imgSrc,
                alt: articleBlock.imgAlt,
                path: 'pages/'+this.data.folder+'/'+this.data.sortedIDs[this.articleIndex]+'/',
                caption: articleBlock.date,
              },
              ['header'+(loadedArticles+1)]: articleBlock.header,
              ['text'+(loadedArticles+1)]: articleBlock.ingress,
              ['link'+(loadedArticles+1)]: {
                linkText: (this.data.folder == 'news') ? 'Read article' : 'Link to article',
                route: 'article/?article='+this.data.sortedIDs[this.articleIndex],
                externalLink: articleBlock.externalLink
              }
            }

            loadedArticles++;
          }
        } catch(e){

        }
        this.articleIndex--;
      }

      this.articles.push({
        ...this.data,
        ...newContent
      });
    },
  },
  data() {
    return {
      articleIndex: this.data.startIndex,
      articles: [],
      loadedContent: {},
      currentArticleIndex: null
    }
  },
  watch: {
    $route() {
      this.updateArticles();
    }
  },
  mounted() {
    // Reading and storing current article Index to avoid loading 
    // duplicate articles in "Other news" under an article
    this.currentArticleIndex = this.$route.query.article;
    this.resetLoadedArticles();
    this.data.linkAll = true;

    // Load first row of content
    this.loadContent();
  },
}



// WEBPACK FOOTER //
// ./components/combinedBlocks/ArticleLoader.vue